/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

export const onClientEntry = () => {
  if (process.env.GATSBY_IS_V2 === 'true') {
    document.documentElement.style.setProperty('--brand-a', '#003359');
    document.documentElement.style.setProperty('--brand-b', '#DE1135');
    document.documentElement.style.setProperty('--brand-c', '#64CFE9');
  }
};
